import { IonContent, IonPage, IonRouterOutlet } from '@ionic/react';
import React from 'react';
import { dashboardPageStyle } from '../../Layout';
import PageTitle from '../../../../components/Dashboard/PageTitle';
import BusinessVerificationPage from './pages/BusinessVerificationPage';
import AccountActionsPage from './pages/AccountActionsPage';
import StoreProfile from './pages/StoreProfilePage';
import LayoutNav from '../../../../components/Dashboard/settings/ui/LayoutNav';
import { Redirect, Route, RouteComponentProps } from 'react-router';
import SecurityAndPrivacy from './pages/SecurityAndPrivacy';
import PayoutsPage from './pages/PayoutsPage';

const navLinks = [
  {
    label: 'Store profile',
    to: '/dashboard/settings/store-profile',
  },
  {
    label: 'Security and privacy',
    to: '/dashboard/settings/security&privacy',
  },
  {
    label: 'Business verification',
    to: '/dashboard/settings/business-verification',
  },
  {
    label: 'Payouts',
    to: '/dashboard/settings/payouts',
  },
  {
    label: 'Account actions',
    to: '/dashboard/settings/account-actions',
  },
];

export default function index({ match }: RouteComponentProps) {
  return (
    <IonPage>
      <IonContent>
        <div className={`${dashboardPageStyle} h-full pr-2 flex flex-col`}>
          <div className="space-y-2">
            <PageTitle>Account Settings</PageTitle>
            <p className="medium-emphasis-text">
              Manage your store profile, security, and business settings
            </p>
            <div className="w-full">
              <LayoutNav navLinks={navLinks} />
            </div>
          </div>
          <div className="relative flex-1">
            <IonRouterOutlet>
              <Route
                path={`${match.path}/store-profile`}
                exact
                component={StoreProfile}
              />
              {/* <Route
                path={`${match.path}/role-management`}
                exact
                render={() => <ComingSoonPage title="Role management" />}
                // component={RoleManagement}
              /> */}
              <Route
                path={`${match.path}/security&privacy`}
                exact
                component={SecurityAndPrivacy}
              />
              <Route
                path={`${match.path}/business-verification`}
                exact
                component={BusinessVerificationPage}
              />
              <Route
                path={`${match.path}/payouts`}
                exact
                component={PayoutsPage}
              />
              <Route
                path={`${match.path}/account-actions`}
                exact
                component={AccountActionsPage}
              />
              <Redirect
                to={`${match.path}/store-profile`}
                exact
                from={match.path}
              />
            </IonRouterOutlet>
          </div>
        </div>
      </IonContent>
    </IonPage>
  );
}
